import { IntegrationProvider } from "@repo/app-types/entities/integration";
import {
  knowledgeBaseSyncProviderLabels,
  type KnowledgeBaseSyncProvider as KnowledgeBaseSyncProviderType,
} from "@repo/app-types/entities/knowledgeBaseSync";
import type { FC } from "react";
import { twMerge } from "tailwind-merge";
import guruLogoSrc from "./assets/guruLogo.png";
import kustomerLogoSrc from "./assets/kustomerLogo.png";

const providerLogoSrc: Record<KnowledgeBaseSyncProviderType, string> = {
  [IntegrationProvider.KUSTOMER]: kustomerLogoSrc,
  [IntegrationProvider.GURU]: guruLogoSrc,
};

interface KnowledgeBaseSyncProviderLogoProps {
  provider: KnowledgeBaseSyncProviderType;
  className?: string;
}

/** The configured provider's logo mark. */
export const KnowledgeBaseSyncProviderLogo: FC<
  KnowledgeBaseSyncProviderLogoProps
> = (props) => {
  const { provider, className } = props;

  return (
    <img
      alt={knowledgeBaseSyncProviderLabels[provider]}
      src={providerLogoSrc[provider]}
      className={twMerge("shrink-0 rounded-md object-contain", className)}
    />
  );
};
